import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';

interface BackToDashboardButtonProps {
  className?: string;
  customReturnPath?: string;
  buttonText?: string;
}

const BackToDashboardButton: React.FC<BackToDashboardButtonProps> = React.memo(({
  className = '',
  customReturnPath,
  buttonText = 'Back to Dashboard'
}) => {
  const { user } = useAuth();

  // Memoize the target path to prevent unnecessary recalculations
  const targetPath = useMemo(() => {
    if (customReturnPath) {
      return customReturnPath;
    } else if (user?.role === 'seller' || user?.role === 'Seller' || user?.is_seller) {
      return '/seller/dashboard';
    } else {
      // For buyers or any other role, go to profile
      return '/profile';
    }
  }, [customReturnPath, user?.role, user?.is_seller]);

  return (
    <Link
      to={targetPath}
      className={`inline-flex items-center space-x-2 px-3 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 ${className}`}
      aria-label={buttonText}
    >
      <ArrowLeft className="h-4 w-4" />
      <span>{buttonText}</span>
    </Link>
  );
});

BackToDashboardButton.displayName = 'BackToDashboardButton';

export default BackToDashboardButton;